//
// OzzyDragBasket Version 0.7
// Written by Osman Ilyas.
// Copyright (c) 2012-2016 Ozzypod. <ozzy@ozzypod.com>
// All Rights Reserved.
//
// For commercial licenses please contact me at the above email address
//
// Please retain this copyright header in all versions of the software
//

(function($) {
$.fn.OzzyDragBasket = function(options) {

  return this.each(function() {

  var namespace = '#'+$(this).attr("id");
    // console.log({namespace});

    var settings = $.extend(true,
    /* defaults */
    {
        url		: 'error.json',
        ajax		: {
        		    post	: '/cart/add.js',
        		    success	: function(data, textStatus, jqXHR) { alert("Your order has been added to your cart."); },
        		    error	: function(jqXHR, text, e) { alert("An error has occured: "+(e.code||e)+"\n\nPlease try again later."); },
        		  },
        slot		: {
        		    width	: 100,
        		    height	: 100,
        		    imgWidth	: 99,
        		    imgHeight	: 99,
        		    infoWidth	: 80,
        		    infoTop	: -34
        		  },
        layers		: 1,
        width		: 6,
        height		: 3,
        dir		: "vertical",
        weight		: null,
        cost		: null,
        weightUnit	: "kg",
        currency	: "&pound;",
        byWeight	: false,
        classNames	: {
        		    panelParent		: '.panel-parent',
        		    panelTab		: '.panel-tabs',
        		    panelGroup		: '.panel-group',
        		    panel			: '.panel',
        		    basketParent	: '.basket-parent',
        		    basketGroup		: '.basket-group',
        		    basket			: '.basket',
        		    basketMenu		: '.basket-menu',
        		    basketSlot		: '.basket-slot',
        		    basketSlotFull	: '.basket-slot-full',
        		    basketSlotHelper	: '.basket-slot-helper',
        		    product			: '.product',
        		    resetBasket		: '.clearBasket',
        		    resetLayer		: '.clearLayer',
        		    viewLayer		: '.viewLayer',
        		    basketPrice		: '.basketPrice',
        		    basketWeight	: '.basketWeight',
        		    orderBox		: '.orderBox'
        		  },
		exportMode	: 'shopify', /* magento | shopify */
		basketId	: '27966811143', /* basket product id for shopify */
      	owners : []
    }, options);

    // store product categories
    var categories = new Array();

    // helper object to sanitize user input grid
    var grid = {
      z : Math.min(5, Math.max(1,parseInt(settings.layers))),
      x : Math.min(10, Math.max(4,parseInt(settings.width))),
      y : Math.min(10, Math.max(1,parseInt(settings.height)))
    }

    // store the current basket
    var basket = new Basket(grid.z, grid.x, grid.y, settings.weight, settings.cost, settings.byWeight);

    function Category(id, name, url) {
      this.id = namespace+"_"+id;
      this.name = name;
      this.url = url;
      this.products = new Array();
      this.getTabLink = function() {
        return "<li><a href=\""+this.id+"\">"+this.name+"</a></li>";
      }
      this.getTabContainer = function() {
        return "<div id=\""+(this.id).substr(1)+"\" class=\""+(settings.classNames.panel).substr(1)+"\"></div>";
      }
      // detect if category products has loaded
      this.ready = false;
    }

    function Product(id, name, description, img_url, weight, price) {
      this.id = id;
      this.name = name;
      this.description = description;
      this.img_url = img_url;
      this.weight = weight;
      this.price = price;
      this.getHTML = function() {
        return ("<div class=\""+(settings.classNames.product).substr(1)+"\">"
                + "<div class=\"menu\"><a class=\"pinfo\" rel=\""+this.id+"\"></a><a class=\"trash\"></a></div>"
                + "<img src=\""+this.img_url+"\">"
                + "<div class=\"info\">"+this.name+"</div>"
                + "</div>"
               );
      }
      this.getJSON = function(z,x,y) {
        return ('{'
                + '"layer":"'+z+'",'
                + '"x":"'+x+'",'
                + '"y":"'+y+'",'
                + '"id":"'+this.id+'",'
                + '"name":"'+this.name+'",'
                + '"description":"'+this.description+'",'
                + '"img_url":"'+this.img_url+'",'
                + '"weight":"'+this.weight+'",'
                + '"price":"'+this.price+'"'
                + '},'
               );
      }
	  this.getShopifyJSON = function(z,x,y) {
      	return ('"Pos: '+x+','+y+','+z+'":"'+this.name+'",');
	  }
      // keep a copy
      Product.products[this.id] = this;
    }
    // static access to all instances
    Product.products = {};
    // obtain a product by its id
    Product.getProduct = function(p_id) {
      return this.products[p_id];
    }

    function Basket(layers, width, height, weight, cost, byWeight) {
      // initialise this basket
      this.layers = layers;
      this.width = width;
      this.height = height;
      this.weight = weight;
      this.cost = cost;
      this.byWeight = byWeight;
      this.products = new Array(layers);
		
      for (var i=0; i<layers; i++) {
        this.products[i] = new Array(width);
        for (var j=0; j<width; j++) {
          this.products[i][j] = new Array(height);
        }
      }
	  
	  this.productQuantities = new Array();
	  
      // convenience methods
      this.setProduct = function(p_id, z, x, y) {
        this.products[z][x][y] = p_id;
        updateBasketInfo();
      }
      this.unsetProduct = function(z, x, y) {
        this.products[z][x][y] = null;
        updateBasketInfo();
      }
      this.clear = function(layer) {
        for (var i=0; i<this.products.length; i++) {
          if (i==layer || layer==null) {
            for (var j=0; j<this.products[i].length; j++) {
              for (var k=0; k<this.products[i][j].length; k++) {
                this.unsetProduct(i,j,k);
              }
            }
            if (i==layer) break;
          }
        }
      }
      this.aggregate = function(method) {
        var total = 0;
        var output = "";
		var pid_qtys = new Array();
		  
        loop:
        for (var i=0; i<this.products.length; i++) {
          for (var j=0; j<this.products[i].length; j++) {
            for (var k=0; k<this.products[i][j].length; k++) {
              var p = Product.getProduct(this.products[i][j][k]);
				
              if (p!=null) switch(method) {
                case Basket.WEIGHT:
                  total += parseFloat(p.weight); break;
                case Basket.PRICE:
                  total += (this.byWeight)? parseFloat(p.weight)*parseFloat(p.price) : parseFloat(p.price); break;
                case Basket.EXPORT_MAGENTO_JSON:
                  output += p.getJSON(i,j,k); break;
				case Basket.EXPORT_SHOPIFY_JSON:
				  output += p.getShopifyJSON(i,j,k); break;
				case Basket.COUNT_PID_QTY:
				  if (pid_qtys[p.id]) {
				  	  pid_qtys[p.id] = parseInt(pid_qtys[p.id])+1;
				  } else {
				  	  pid_qtys[p.id] = 1;
				  }
				  break;
                default: break loop;
              }
            }
          }
        }
        switch(method) {
          case Basket.WEIGHT:
            return (this.weight!==null&&this.weight>0)? total+this.weight : total; break;
          case Basket.PRICE:
            return (this.cost!==null&&this.cost>0)? total+this.cost : total; break;
          case Basket.EXPORT_MAGENTO_JSON:
            return ('{ "basket": { "quantity":"'+qty+'", "products":['+output.slice(0,-1)+'] } }'); break;
		  case Basket.EXPORT_SHOPIFY_JSON:
            return ('{'+output.slice(0,-1)+'}'); break;
	      case Basket.COUNT_PID_QTY:
			return pid_qtys; break;
          default: return 0; break;
        }
      }
	  
	  this.updateProductQuantities = function() {
	  	this.productQuantities = this.aggregate(Basket.COUNT_PID_QTY);
	  }
	  
	  // basket.getShopifyJSON
	  this.getShopifyJSON = function(quantity, owner, basketKey) {
		this.updateProductQuantities();
		  
		var properties = '"_owner":"'+owner+'",';
        properties += '"_basketNo":"'+basketKey+'",';
		properties += '"_basketClass":"basket",';
        
		var p_ids = Object.keys(this.productQuantities);
		for (var i=0; i<p_ids.length; i++) {
			var pid = p_ids[i];
			var qty = this.productQuantities[pid];
			properties += '"'+Product.getProduct(pid).name+'":"Qty '+qty+'",';
		}
        
        return ('{ "id": "'+settings.basketId+'",'
                +' "quantity": "'+quantity+'",'
                +' "properties": {'+properties.slice(0,-1)+'}'
                +'}');
		
	  }
    }
	
	  
    // aggregate function constants
    Basket.PRICE = 0;
    Basket.WEIGHT = 1;
	Basket.COUNT_PID_QTY = 2;
    Basket.EXPORT_MAGENTO_JSON = 10;
	Basket.EXPORT_SHOPIFY_JSON = 11;

    // function to create the products panel
    function initProductsPanel() {
      // define templates
      var panelParent = "<div class=\""+(settings.classNames.panelParent).substr(1)+"\"></div>";
      var tabMenu = "<ul class=\""+(settings.classNames.panelTab).substr(1)+"\"></ul>";
      var tabBox = "<div class=\""+(settings.classNames.panelGroup).substr(1)+"\">";

      // create product panel
      $(namespace).prepend(panelParent);
      $(namespace+' '+settings.classNames.panelParent)
          .append(tabMenu)
          .append(tabBox);

      // add categories, load products
      for (var i=0; i<categories.length; i++) {
        $(namespace+' '+settings.classNames.panelTab).append(categories[i].getTabLink());
        $(namespace+' '+settings.classNames.panelGroup).append(categories[i].getTabContainer());
        loadCatProducts(categories[i]);
      }

      // wait for ajax to finish before continuing
      var timer = setInterval(function() {
        var allReady = +categories[0].ready;
        for (var i=0; i<categories.length; i++) allReady = Math.min(+categories[i].ready, +allReady);
        if (allReady) {
          updateWidths();
          initProductMenu();
          initBasket();
          clearInterval(timer);
        }
      }, 50);
    }

    // load the products for a given category
    function loadCatProducts(cat) {
      $.ajax({
        type: "GET",
        url: cat.url,
        dataType: "json",
        success: function(data) {
          for (var i=0; i<data.products.length; i++) {
            var p = data.products[i];
			// skip products if there are no images
			if (p.images.length) {
	            var product = settings.exportMode=="shopify"?
					  new Product(p.variants[0].id, p.title, p.body_html, p.images[0].src, p.variants[0].grams/1000, p.variants[0].price)
					  : new Product(p.id, p.name, p.description, p.img_url, p.weight, p.price);
            	cat.products.push(product);
            	$(cat.id).append(product.getHTML());
			}
          }
          cat.ready = true;
        },
        error: function(jqXHR, text, e) {
          console.log("Ajax Failure: "+text+"\nDetails:"+e);
        }
      });
    }

    // function to keep the products panel flowing horizontally
    function updateWidth(cat_id) {
      $(cat_id).animate({width: '0'}, 200, function() {
        var new_width = settings.slot.width*parseInt(document.getElementById((cat_id).substr(1)).getElementsByClassName((settings.classNames.product).substr(1)).length);
        $(this).css({width: new_width+'px'});
      });
    }
    function updateWidths() {
      for (var i=0; i<categories.length; i++) {
        updateWidth(categories[i].id);
      }
    }

    function initProductMenu() {
      $(namespace+' '+settings.classNames.product).css({
        width: settings.slot.width+"px",
        height: settings.slot.height+"px"
      });
      $(namespace+' '+settings.classNames.product+'>img').css({
        width: settings.slot.imgWidth+"px",
        height: settings.slot.imgHeight+"px"
      });
      $(namespace+' '+settings.classNames.product+' .info').css({
        width: settings.slot.infoWidth+"px",
        top: settings.slot.infoTop+"px"
      });
    }

    // function to create a basket grid defined by user-input
    function initBasket() {
      // define templates
      var basketParent = "<div class=\""+(settings.classNames.basketParent).substr(1)+"\"></div>"
      var basketGroup = "<div class=\""+(settings.classNames.basketGroup).substr(1)+"\"></div>";
      var basketLayer = "<div class=\""+(settings.classNames.basket).substr(1)+"\"></div>";
      var gridSlot = "<div class=\""+(settings.classNames.basketSlot).substr(1)+"\"></div>";

      // create the basket
      $(namespace).append(basketParent);
      $(namespace+' '+settings.classNames.basketParent).append(basketGroup);
      var total = grid.x*grid.y;
      for (var i=0; i<grid.z; i++) {
        $(namespace+' '+settings.classNames.basketGroup).append(basketLayer);
        for (var j=0; j<total; j++) {
          $(namespace+' '+settings.classNames.basket+':eq('+i+')').append(gridSlot);
        }
      }

      // update the basket dimensions
      $(namespace+' '+settings.classNames.basket+','+namespace+' '+settings.classNames.basketParent).css({
        width: grid.x*settings.slot.width+"px",
        height: grid.y*settings.slot.height+"px"
      });
      $(namespace+' '+settings.classNames.panelParent).css({
        width: (grid.x*settings.slot.width-10)+"px",
        height: 65+settings.slot.height+"px",
        overflow: "hidden"
      });
      $(namespace+' '+settings.classNames.panel+','+namespace+' '+settings.classNames.panelGroup).css({
        height: 15+settings.slot.height+"px"
      });
      $(namespace+' '+settings.classNames.basketParent).css({
        overflow: "hidden"
      });

      if (settings.dir=="h") {
        $(namespace+' '+settings.classNames.basket).css({
          float: 'left'
        });
        $(namespace+' '+settings.classNames.basketGroup).css({
          width: grid.z*grid.x*settings.slot.width+"px",
          height: grid.y*settings.slot.height+"px"
        });
      }

      $(namespace+' '+settings.classNames.basketSlot+','+namespace+' '+settings.classNames.basketSlotFull).css({
        width: settings.slot.width+"px",
        height: settings.slot.height+"px"
      });

      initBasketMenu();
    }

    // function to create a menu to control the basket
    function initBasketMenu() {
      // define templates
      var basketMenu = "<div class=\""+(settings.classNames.basketMenu).substr(1)+"\"></div>";
      var resetBtn = "<button class=\""+(settings.classNames.resetBasket).substr(1)+"\">Start Over</button>";
      var resetLayerBtn = "<button id=\""+(namespace).substr(1)+"_"+(settings.classNames.resetLayer).substr(1)+"\" class=\""+(settings.classNames.resetLayer).substr(1)+" l0\">Clear</button>";
      var viewLayerBtn = "<select class=\""+(settings.classNames.viewLayer).substr(1)+"\" onchange=\"this.className=this.value\"></select>";
      var basketPrice = "<div class=\""+(settings.classNames.basketPrice).substr(1)+"\">0.00</div>";
      var basketWeight = "<div class=\""+(settings.classNames.basketWeight).substr(1)+"\">0.000</div>";
      var orderBox = "<div class=\""+(settings.classNames.orderBox).substr(1)+"\"></div>";
      var orderForm = "<form action=\"javascript: /*do nothing*/;\" accept-charset=\"utf-8\"></form>";
      var orderQty = "Qty: <input name=\"qty\" type=\"text\" size=\"3\" value=\"1\">";
      
      var orderOwner = "";
      if (settings.owners.length > 0) {
        var owner_names = "";
        for (var nidx=0; nidx<settings.owners.length; nidx++) {
          owner_names += "<option value=\""+settings.owners[nidx]+"\">"+settings.owners[nidx]+"</option>";
        }
      	orderOwner = "Owner: <select name=\"owner\">"+owner_names+"</select>";
      } else {
        orderOwner = "<input type=\"hidden\" name=\"owner\" value=\"You\"/>";
      }
      
      var orderBtn = "<button id=\""+(namespace).substr(1)+"_addToCart"+"\">Add to Cart</button>";
	  var addToCartDialog = "<div id=\""+(namespace).substr(1)+"_addToCartDialog"+"\" title=\"Process Cart\" style=\"display:none;\"></div>";
	  var addToCartProgressLabel = "<div class=\"progress-label\"></div>";
	  var addToCartProgress = "<progress max=\"100\" value=\"0\" id=\""+(namespace).substr(1)+"_addToCartProgress"+"\"></progress>";
		
	  // add the addToCart dialog
	  $(namespace).append(addToCartDialog);
	  $(namespace+'_addToCartDialog')
			.append(addToCartProgressLabel)
			.append(addToCartProgress);

      // create the menu
      $(namespace).append(basketMenu);
      $(namespace+' '+settings.classNames.basketMenu)
          .append(viewLayerBtn)
          .append(resetLayerBtn)
          .append(basketPrice)
          .append(basketWeight)
          .append(resetBtn)
          .append(orderBox);
      $(namespace+' '+settings.classNames.orderBox)
          .append(orderForm)
          .find("form")
              .append(orderQty)
      		  .append(orderOwner)
              .append(orderBtn);
      for (var i=0; i<grid.z; i++)
        $(namespace+' '+settings.classNames.viewLayer)
          .append("<option value=\""+(settings.classNames.viewLayer).substr(1)+" l"+i+"\">Layer "+(i+1)+"</option>");

      // update the dimensions
      $(namespace+' '+settings.classNames.basketMenu).css({
        width: (grid.x*settings.slot.width-10)+"px",
        height: (21+settings.slot.height)+"px"
      });

      // complete the initialisation sequence
      initUI();
    }

    // helper to translate an element index to a grid position
    function getPosition(index) {
      return {
        z: parseInt($(namespace+' '+settings.classNames.resetLayer).attr("class").slice(-1)),
        x: index%grid.x,
        y: Math.floor(index/grid.x)
      };
    }

    // helper to update the basket price and weight
    function updateBasketInfo() {
      $(namespace+' '+settings.classNames.basketPrice).html(settings.currency+" "+(basket.aggregate(Basket.PRICE)).toFixed(2));
      $(namespace+' '+settings.classNames.basketWeight).html((basket.aggregate(Basket.WEIGHT)).toFixed(3)+" "+settings.weightUnit);
    }

    // create the sortable interface
    function initUI() {
      // create tabs
      $(namespace+' '+settings.classNames.panelParent).tabs({
        fx: { opacity: 'toggle' }
      });
      $(namespace+' '+settings.classNames.panelParent+','+settings.classNames.panelTab).css({borderRadius: '8px 8px 0 0'});

      // cache the last sortable to return stacked items
      var $last_item;
      // allow product panel products to be swapped around
      $(namespace+' '+settings.classNames.panel).sortable({
        // enabled drop in basket slots
        connectWith: namespace+' '+settings.classNames.basket+' '+settings.classNames.basketSlot,
        dropOnEmpty: true,
        placeholder: (settings.classNames.basketSlotHelper).substr(1),
        revert: 'invalid',
        scroll: false,
        // clone item when removed
        remove: function(event, ui) {
          (ui.item).clone().appendTo($(this));
        },
        // necessary when using tabs
        helper: 'clone',
        appendTo: 'body',
        // fix display added by helper
        beforeStop: function(event, ui) {
          (ui.item).css({display:''});
        }
      }).disableSelection();

      // allow product basket products to be swapped around
      $(namespace+' '+settings.classNames.basket+' '+settings.classNames.basketSlot).sortable({
        // drop in products panel and other basket slots
        connectWith: namespace+' '+settings.classNames.basket+' '+settings.classNames.basketSlot+','
                   + namespace+' '+settings.classNames.basket+' '+settings.classNames.basketSlotFull,
        dropOnEmpty: true,
        placeholder: (settings.classNames.basketSlotHelper).substr(1),
        revert: 'invalid',
        scroll: false,
        // check if the receiving slot is full, if so swap items between basket slots
        receive: function() {
          console.log("drag and drop");
          if($(this).attr("class") == (settings.classNames.basketSlotFull).substr(1)) {
            // return the stacked item
            $(this).find(settings.classNames.product+":eq(1)").appendTo($last_item);
            // update the slot status of the returned item to full
            $last_item.attr("class", (settings.classNames.basketSlotFull).substr(1));
            var last_pos = getPosition($last_item.index());
            var last_p_id = $last_item.find('.pinfo').attr("rel");
            basket.setProduct(last_p_id, last_pos.z, last_pos.x, last_pos.y);
          } else {
            // set the slot to full status
            $(this).attr("class", (settings.classNames.basketSlotFull).substr(1));
          }
          var pos = getPosition($(this).index());
          var p_id = $(this).find('.pinfo').attr("rel");
          basket.setProduct(p_id, pos.z, pos.x, pos.y);
        },
        // reset slot status to empty when item is removed
        remove: function() {
          $(this).attr("class", (settings.classNames.basketSlot).substr(1));
          var pos = getPosition($(this).index());
          basket.unsetProduct(pos.z, pos.x, pos.y);
          $last_item = $(this);
        }
      }).disableSelection();

      // bind events to menus

      // product menu trash icon event
      $('body').on('click', namespace+' '+settings.classNames.product+' .menu .trash', function() {
        var $slot = $(this).parent().parent().parent();
        var pos = getPosition($slot.index());
        basket.unsetProduct(pos.z, pos.x, pos.y);
        $slot.attr("class", (settings.classNames.basketSlot).substr(1));
        $slot.find('.product').hide('explode', {'pieces':16}, 600, function() {
          $(this).remove();
        });
      });

      // basket menu reset basket event
      $(namespace+' '+settings.classNames.resetBasket).click(function() {
        basket.clear();
        $(namespace+' '+settings.classNames.basket+' '+settings.classNames.product).fadeOut('slow', function() {
          $(this).remove();
          $(namespace+' '+settings.classNames.basketSlotFull).attr("class", (settings.classNames.basketSlot).substr(1));
        });
      });
      // basket menu clear layer event
      $('body').on('click', namespace+' '+settings.classNames.resetLayer, function() {
        var layer = $(this).attr("class").slice(-1);
        basket.clear(layer);
        $(namespace+' '+settings.classNames.basket+':eq('+layer+') '+settings.classNames.product).fadeOut('slow', function() {
          $(this).remove();
          $(namespace+' '+settings.classNames.basket+':eq('+layer+') '+settings.classNames.basketSlotFull).attr("class", (settings.classNames.basketSlot).substr(1));
        });
      });
      // basket menu switch layer event
      $(namespace+' '+settings.classNames.viewLayer).change(function() {
        var layer = $(this).attr("class").slice(-1);
        $(namespace+' '+settings.classNames.basketParent).animate({
          scrollLeft: layer*grid.x*settings.slot.width + "px",
          scrollTop: layer*grid.y*settings.slot.height + "px"
        }, 'slow');
        $(namespace+'_'+(settings.classNames.resetLayer).substr(1)).attr("class", ((settings.classNames.resetLayer).substr(1)+" l"+layer));
      });
      // basket menu add basket to cart
      $(namespace+'_addToCart').click(function() {
        if (settings.exportMode=='shopify') {
          var owner = this.form.owner.options? this.form.owner.options[this.form.owner.selectedIndex].value : this.form.owner.value;
          processShopifyBasket(this.form.qty.value, owner);
        }
		else processMagentoBasket(this.form.qty.value);
      });
    }

    // start the program by importing the product categories
    function load(categories_url) {
      $.ajax({
        type: "GET",
        url: categories_url,
        dataType: "json",
        success: function(data) {
          for (var i=0; i<data.categories.length; i++) {
            var cat = data.categories[i];
            categories.push(new Category(cat.id, cat.name, cat.url));
          }
          // run load sequence
          initProductsPanel();
        },
        error: function(jqXHR, text, e) {
          console.log("Ajax Failure: "+text+"\nDetails:"+e);
        }
      });
    }

    // run the program
    load(settings.url);

    // process the order
    function processMagentoBasket(qty) {
      $.ajax({
        type: "POST",
        url: settings.ajax.post,
        dataType: 'json',
        data: {json:basket.aggregate(Basket.EXPORT_MAGENTO_JSON, qty)},
        success: function(data, textStatus, jqXHR) {
          if (typeof settings.ajax.success == "function") settings.ajax.success(data, textStatus, jqXHR); 
        },
        error: function(jqXHR, text, e) {
          if (typeof settings.ajax.error == "function") settings.ajax.error(jqXHR, text, e); 
        }
      });
    }
	
	// process shopify order
	function processShopifyBasket(qty, owner) {
		//var eachPrice = basket.aggregate(Basket.PRICE);
		//var eachWeight = basket.aggregate(Basket.WEIGHT);
      
		var basketKey = Math.random().toString(36).substring(7);
      
      	var basketProperties = JSON.parse(basket.getShopifyJSON(qty, owner, basketKey));
      /*
      	var basketProperties = {
			id: settings.basketId,
			quantity: qty,
          	properties: {
              _basketNo: basketKey,
              _basketClass: "basket",
              _owner: owner
            }
		}
      */
      	
		var toAdd = new Array();
		for (var i=0; i<basket.products.length; i++) {
          for (var j=0; j<basket.products[i].length; j++) {
            for (var k=0; k<basket.products[i][j].length; k++) {
              var p = Product.getProduct(basket.products[i][j][k]);
			  if (p!=null) 
				  toAdd.push({
					  id: p.id, 
					  quantity: qty, 
					  properties: { 
						  _basketNo: basketKey, 
						  _basketClass: "basketItem"
					  }});
            }
          }
        }
		
		var numItems = toAdd.length + 1;
		
        var cart_label = settings.owners.length<2? "your cart" : owner+"&apos;s cart";
		
		function processShopifyCart() {
			if (toAdd.length) {
              console.log({toAdd});
				$.post("/cart/add.js", toAdd.shift())
					.success(function() { processShopifyCart(); })
					.error(function() { processShopifyCart(); });
			} else {
				$.post("/cart/add.js", basketProperties)
					.success(function() { hideAddToCartProgress(numItems, cart_label); })
					.error(function() { hideAddToCartProgress(numItems, cart_label); });
			}
			// update progress bar
	    	var progressbar = $('#'+(namespace).substr(1)+"_addToCartProgress" ),
	      		progressLabel = $( ".progress-label" );
	      	progressbar.prop("value", Math.round(100*(1-((toAdd.length+1)/numItems))));
			progressLabel.text("Adding items to "+cart_label+"..."+toAdd.length+"/"+numItems+" remaining...");
		}
		
		showAddToCartProgress(numItems, cart_label);
		processShopifyCart();
	}
	
	// show adding to cart status
	function showAddToCartProgress(numItems, cart_label) {
	    var progressbar = $('#'+(namespace).substr(1)+"_addToCartProgress"),
	      progressLabel = $( ".progress-label" ),
	      dialog = $('#'+(namespace).substr(1)+"_addToCartDialog");
      
		progressLabel.text("Adding "+numItems+" items to "+cart_label+".");
		
		dialog.dialog({
	        autoOpen: true,
			modal: true
	      });
	}
	
	// hide adding to cart status
	function hideAddToCartProgress(numItems, cart_label) {
		// update progress bar
    	var dialog = $('#'+(namespace).substr(1)+"_addToCartDialog"),
			progressbar = $('#'+(namespace).substr(1)+"_addToCartProgress"),
      		progressLabel = $( ".progress-label" );
      	progressbar.prop("value", 100);
		progressLabel.text(numItems+" items were added to "+cart_label+".");
		dialog.dialog({
			buttons: {
				"Go to Cart": function() {
					window.location.replace("/cart");
				}
			}
		  });
	}
	
  });
};
})(jQuery);